import { FieldUploadFile } from '@smx-ui-inspector/component-field/field-upload-file';
import { BaseContextType } from '@smx-ui-model/types';
import { DatePicker, Form } from 'antd';

import FormButtonSaveSetDrawings from '../components/form-button-save-set-drawings';
import { createDrawingSetVersionMutation } from '../graphql/mutation/create-drawing-set-version-mutation';
import { drawingSetVersionCoreModel } from './drawing-set-version-core-model';
import { DrawingSetVersionModelSchemaType } from './types';

export const drawingSetVersionModel: DrawingSetVersionModelSchemaType<BaseContextType> = {
    ...drawingSetVersionCoreModel,
    renderData: {
        inspectorField: {
            fileName: () => {
                return <FieldUploadFile />;
            },
            versionDate: () => {
                return (
                    <Form.Item name="versionDate" label="Set version date" rules={[{ required: true }]}>
                        <DatePicker format={'YYYY-MM-DD hh:mm:ss'} />
                    </Form.Item>
                );
            },
        },
    },
    action: {
        inspector: [
            ({ entity, values, form, connectionId }) => {
                return (
                    !entity && (
                        <FormButtonSaveSetDrawings
                            mutation={createDrawingSetVersionMutation}
                            responseSource={'createDrawingSetVersion'}
                            values={values}
                            form={form}
                            connectionId={connectionId}
                        />
                    )
                );
            },
        ],
    },
};
